import React, { useEffect, useState } from "react";
import "./JobCard.css";
import { Row, Col } from "antd";
import { FastBackwardFilled, StarFilled } from "@ant-design/icons";
import candidate from "../../assets/img/becomeACandidate.png";
import AI_Suggested from "../../assets/img/AI_Suggested.png";
import threedotwhite from "../../assets/img/threedotwhite.png";
import { useLocation } from "react-router-dom";
import { Menu, Dropdown, message } from "antd";
import { Modal, Button, Rate } from "antd";
import moment from "moment";
import {
  deleteJob,
  updateGig,
  getJobListing,
  getSkillMatches,
} from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import history from "../../routes/history";
import facilitynameicon from "../../assets/img/facilitynameicon.png";
import bannerImage from "../../assets/img/banners/city-view.jpg";
import TopAlert from "../TopNotification/TopAlert";
import { Tooltip } from "antd";
import { getImageByStateCode } from "../../pages/CompanyProfile/components/cloudinary";
import PrivateGigTag from "../../assets/icons/PrivateGigTag.svg";
import { DefaultRating } from "../../assets/helpers";
import PrivateTag from "../../assets/icons/PrivateTag.svg";
import PrivateGigsTag from "../../pages/SearchSkillListing/components/AllGigs/PrivateGigsTag";
import { getRelativeTime,generateFinalUrl } from "../../shared/helpers";
import { TAL_AUTO_SUGGESTED } from "../../shared/constants";
export default function JobCard({ showAI = false, ...props }) {
  const dispatch = useDispatch();
  var budget = 0;
  if (typeof props.budget === "object" && props.budget?.$numberDecimal) {
    const { $numberDecimal } = props.budget;
    budget = $numberDecimal;
  } else {
    budget = props.budget;
  }

  const location = useLocation();
  const isJobDetailPage = location.pathname.includes('/jobdetail');
  const expiry_response = useSelector(
    (state) => state.manageJobsReducer.expiry_success
  );
  const [alertTrue, setAlertTrue] = useState(false);
  // const history=useHistory();
  const [showmodal, setshowmodal] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [imgErrorCheck, setImgErrorCheck] = useState(false);
  const [dimensions, setDimensions] = useState(window.innerWidth);
  const [alternateImage, setAlternateImage] = useState(null);
  // const [cardFooter, setcardFooter] = useState(true)
  useEffect(() => {
    setDimensions(window.innerWidth);
  }, [window.innerWidth]);

  const EditJobHandler = () => {
    let skillDetails = props?.Skills?.map((item) => {
      return {
        skillName: item?.Skills?.SkillName,
        SkillPercent: item?.SkillPercent,
        isDisable: true,
      };
    });

    let industryDetails = props?.Industry?.map((item) => {
      return {
        industryName: item.IndustryName,
        industryPercent: item.IndustryPercent ? item.IndustryPercent : 0,
        isDisable: true,
      };
    });

    history.push({
      pathname: "/contract-gig",

      state: {
        Title: props.title,
        FacilityName: props?.facilityname,
        Skills: skillDetails,
        // Location: props?.location,
        Experience: props.experience,
        Industry: industryDetails,
        Id: props?.id,
        Description: props?.description,
        WorkAuthorization: props?.workauthorization,
        isTemplate: props?.isTemplate,
        FromEdit: true,
        NotTemplate: true,
        IdealContractLengthName: props.IdealContractLengthName,
        Role: props.RoleName,
        employerName: props.employerName,
        BudgetMin: props.BudgetMin,
        img: props.img,
        WorkPolicy: props.WorkplacePolicy,
        JobOrderTypeName: props?.jobOrderType,
        certificates: props?.certificates,
        from: props?.from,
        PermanentJob:
          props?.JobOrderTypes?.JobOrderTypeName == "Permanent" ? true : false,
        openPositions: props?.openPositions,
      },
    });
  };
  const menu = (
    <Menu
      className="joblisting-dropdown"
      // onClick={onClick}
    >
      <Menu.Item key="Edit" onClick={() => EditJobHandler()}>
        Edit
      </Menu.Item>

      <Menu.Item key="Delete" onClick={() => setshowmodal(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const handleOk = () => {
    if (
      (props.matchedbids == 0 || props.matchedbids == null) &&
      props.placedbids == 0 &&
      props.receivedbids == 0
    ) {
      dispatch(
        deleteJob({
          id: props.id,
        })
      );
    } else {
      setAlertTrue(true);
    }

    setshowmodal(false);
  };

  const handleCancel = () => {
    setshowmodal(false);
  };

  const extendExpiry = async () => {
    var extendedDate = new Date();

    extendedDate.setMonth(extendedDate.getMonth() + 1);

    dispatch(
      updateGig({
        ExpiryDate: extendedDate.toISOString(),
        JobOrderStatusName: "Published",
        id: props.id,
      })
    );
    setIsPublished(true);
  };

  const isShowBudgetAmount = () =>
    budget && props.professionCode == "HC" && props?.ExternalGigId > 0;

  const getTopSkills = (skills = []) => {
    if (!Array.isArray(skills) || skills.length === 0) return [];

    return [...skills]
      .sort((a, b) => b.SkillPercent - a.SkillPercent) // Sort by SkillPercent descending
      .slice(0, 3) // Get the top 3 skills
      .map((skill) => ({
        id: skill.Skills.SkillName,
        name: skill.Skills.SkillName,
      }));
  };

  const getArrayObject = (name = "", id = "") => {
    return [{ name, id }];
  };
  const getAsRequiredForQuery = ({
    regions,
    countries,
    cities,
    skills = [],
  }) => {
    let accumulatedFilters = {};
    const addFilterToUrl = (key, value) => {
      if (value !== undefined && value !== null) {
        let encodedValue;

        if (typeof value === "string" || typeof value === "number") {
          encodedValue = String(value).replace(/&/g, "-*");
        } else {
          encodedValue = JSON.stringify(value).replace(/&/g, "-*");
        }

        accumulatedFilters[key] = encodedValue;
      }
    };
    const checkRadioRegion =regions ?  getArrayObject(
      regions?.RegionName,
      regions?.RegionId
    ):undefined;
    const checkRegionId =regions ?  [regions?.RegionId]:undefined;

    const checkRadioCountry =countries ? getArrayObject(
      countries?.CountryName,
      countries?.CountryId
    ):undefined;
    const checkCountryId =countries ? [countries?.CountryId]:undefined;
    //  FOR CITY
    const checkRadioLoc =cities ? getArrayObject(cities?.Location, cities?.CityId):undefined;
    const checkCityId = cities ? [cities?.CityId]:undefined;

    const checkRadioSkill = getTopSkills(skills);
    const checkSkillId = checkRadioSkill.map((el) => el.name);

    const skillsPercentages =skills.sort((a, b) => b.SkillPercent - a.SkillPercent).slice(0, 3).map((el) => el.SkillPercent);

    const values = [
      { key: "Region", value: checkRadioRegion },
      { key: "regionId", value: checkRegionId },
      { key: "Country", value: checkRadioCountry },
      { key: "countryId", value: checkCountryId },
      { key: "City", value: checkRadioLoc },
      { key: "cityId", value: checkCityId },
      { key: "Skill", value: checkRadioSkill },
      { key: "skillsId", value: checkSkillId },
      {key:'skillsPercentages',value: skillsPercentages},
      {key:'searchType', value: TAL_AUTO_SUGGESTED},
      {key:'isTalentSuggestion',value: true}
    ];
    
    values.forEach((el) => addFilterToUrl(el.key, el.value));
    const path = generateFinalUrl("/query", accumulatedFilters);
    localStorage.setItem("talentSearchQuery", path);
    return path
  };

  const handleAISuggestion = () => {
  const isRemote = props?.WorkplacePolicy=="fully-remote"? true : false
    const query = getAsRequiredForQuery({
      regions: isRemote ? undefined: props?.Regions,
      countries: isRemote ? undefined :props?.Countries,
      cities: isRemote ? undefined :props?.Location,
      skills: props?.Skills||props?.JobOrders_Skills,
    });
    localStorage.setItem("gigDetail", JSON.stringify(props));
    history.push(query)
  };

  return (
    <>
      <Modal
        title="Delete this gig?"
        visible={showmodal}
        style={{ color: "#3e3e3e" }}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        width={400}
        centered
      >
        <div className="jobcard-dlttxt">Do you want to delete this gig?</div>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <button
            className="jobcard-modalno noHover"
            style={{ border: "1.5px solid rgb(197, 193, 193)" }}
            key="back"
            onClick={handleCancel}
          >
            No, go back
          </button>
          <button
            className="jobcard-modalyes noHover"
            style={{ border: "solid #118936" }}
            key="submit"
            type="primary"
            onClick={handleOk}
          >
            Yes, delete gig
          </button>
        </div>
      </Modal>

      {expiry_response && isPublished ? (
        <TopAlert
          display={"flex"}
          title={"Gig expiry extended successfully"}
          type="success"
        />
      ) : null}

      {(props.matchedbids !== 0 ||
        props.receivedbids !== 0 ||
        props.placedbids !== 0) &&
      alertTrue ? (
        <TopAlert
          display={"flex"}
          //  title={"You can not delete this Job because there are Bids or interviews associated"}
          title={
            "You cannot delete this gig since you have active bids and interviews associated with this gig"
          }
          type="warning"
        />
      ) : null}

      <div
        className={
          props.jobDetailScreen ? "joblisting-card" : "joblisting-card-listing"
        }
      >
        <div>
          <Row
            className={
              props.jobDetailScreen
                ? "jobcard-img-cont-details"
                : "jobcard-img-cont"
            }
          >
           {showAI ? (
        <div
        onClick={() => handleAISuggestion()}
        className="ai-image-tag"
      >
        <img
          src={AI_Suggested}
          alt="candidate"
          className="ai-image-tag"
        />
      </div>
    ) : null}
            {
              <div
                style={{
                  background: "red",
                  width: "90%",
                  margin: "auto",
                  display: props.jobDetailScreen ? "none" : "flex",
                  justifyContent: "end",
                }}
              >
                {props?.fromJobListingPage ? (
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <img
                      src={threedotwhite}
                      className="jobcard-img"
                      alt="threedots"
                    ></img>
                  </Dropdown>
                ) : null}

                {!props?.fromDashboard ? (
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <img
                      src={threedotwhite}
                      className="jobcard-img"
                      alt="threedots"
                    ></img>
                  </Dropdown>
                ) : null}
              </div>
            }
            {alternateImage == null && !imgErrorCheck ? (
              <img
                onClick={() => {
                  if (!props.jobdetpage && props.cardFooter) {
                    history.push({
                      pathname: `/jobdetail/${props?.id}`,
                      state: {
                        id: props?.id,
                        img: props.img,
                        title: props.Title,
                        facilityname: props.facilityname,
                        budget: props.BudgetMin,
                        screen: props.screen,
                        Rate: props.Rate,
                        indraft: props.indraft,
                        indeleted: props.indeleted,
                        gigId: props.gigId,
                        workpolicy: props.WorkplacePolicy,
                        isDeleted: props.isDeleted,
                        expiryDate: props.expiryDate,
                      },
                    });
                  }
                }}
                src={props.img ?? bannerImage}
                onError={(e) => {
                  // e.target.onerror = null;
                  // e.target.src = bannerImage;
                  if (!imgErrorCheck) {
                    setAlternateImage(
                      getImageByStateCode(props?.RegionCode, "state")
                    );
                    e.target.onerror = null;
                    setImgErrorCheck(true);
                  }
                }}
                alt="jobimg"
                className={
                  props.jobDetailScreen && props.isDeleted
                    ? "joblisting-img-jobDetails joblisting-img-grey"
                    : props.jobDetailScreen
                    ? "joblisting-img-jobDetails"
                    : props.isDeleted || props.closed
                    ? "joblisting-img joblisting-img-grey"
                    : "joblisting-img"
                }
              />
            ) : (
              <img
                onClick={() => {
                  if (!props.jobdetpage && props.cardFooter) {
                    history.push({
                      pathname: `/jobdetail/${props?.id}`,
                      state: {
                        id: props?.id,
                        img: props.img,
                        title: props.Title,
                        facilityname: props.facilityname,
                        budget: props.BudgetMin,
                        screen: props.screen,
                        Rate: props.Rate,
                        indraft: props.indraft,
                        indeleted: props.indeleted,
                        gigId: props.gigId,
                        workpolicy: props.WorkplacePolicy,
                        isDeleted: props.isDeleted,
                        expiryDate: props.expiryDate,
                      },
                    });
                  }
                }}
                src={alternateImage}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = bannerImage;
                }}
                alt="jobimg"
                className={
                  props.jobDetailScreen && props.isDeleted
                    ? "joblisting-img-jobDetails joblisting-img-grey"
                    : props.jobDetailScreen
                    ? "joblisting-img-jobDetails"
                    : props.isDeleted || props.closed
                    ? "joblisting-img joblisting-img-grey"
                    : "joblisting-img"
                }
              />
            )}
            <Col
              className="jobcard-overlay jobcard-overlay-negotiable-margin"
              onClick={() => {
                if (!props.jobdetpage && props.cardFooter) {
                  history.push({
                    pathname: `/jobdetail/${props?.id}`,
                    state: {
                      id: props?.id,
                      img: props.img,
                      title: props.Title,
                      facilityname: props.facilityname,
                      budget: props.BudgetMin,
                      screen: props.screen,
                      Rate: props.Rate,
                      indraft: props.indraft,
                      indeleted: props.indeleted,
                      gigId: props.gigId,
                      workpolicy: props.WorkplacePolicy,
                      isDeleted: props.isDeleted,
                      expiryDate: props.expiryDate,
                    },
                  });
                }
              }}
            >
              <div style={{ width: "max-content" }}>
                {props.jobdetpage && isShowBudgetAmount() ? (
                  budget == 0 ? (
                    props.professionCode == "IT" ? null : (
                      <div
                        className={`${
                          props.isDeleted || props.closed
                            ? "jobcard-price1-deleted"
                            : "jobcard-price1"
                        }`}
                      >
                        <div>$ negotiable</div>
                        <div className="jobcard-paypackge">
                          Estimated pay package
                        </div>
                      </div>
                    )
                  ) : (
                    <div
                      className={`${
                        props.isDeleted || props.closed
                          ? "jobcard-price1-deleted"
                          : "jobcard-price1"
                      }`}
                    >
                      <div>
                        {/* ${budget}{props.rate == "Hour" ? "/HR" : props.rate == "Week" ? "/WK" : props.rate == "Year" ? "/YR": ""} */}
                        ${budget.toLocaleString("en-US")}
                        {`/`}
                        {props?.budgetType?.toUpperCase()}
                      </div>
                      <div className="jobcard-paypackge">
                        Estimated pay package
                      </div>
                    </div>
                  )
                ) : null}
              </div>
              <div>
                {(props.location || props.CityName || props.RegionCode) &&
                props.jobdetpage ? (
                  <div className="jobcard-loc">
                    {props.location || props.CityName || props.RegionCode
                      ? props.location ??
                        props.CityName + ", " + props.RegionCode
                      : "N/A"}
                  </div>
                ) : null}
              </div>
            </Col>
          </Row>
          <div
            onClick={() => {
              if (!props.jobdetpage && props.cardFooter) {
                history.push({
                  pathname: `/jobdetail/${props?.id}`,
                  state: {
                    id: props?.id,
                    img: props.img,
                    title: props.Title,
                    facilityname: props.facilityname,
                    budget: props.BudgetMin,
                    screen: props.screen,
                    Rate: props.Rate,
                    indraft: props.indraft,
                    indeleted: props.indeleted,
                    gigId: props.gigId,
                    workpolicy: props.WorkplacePolicy,
                    isDeleted: props.isDeleted,
                    expiryDate: props.expiryDate,
                    isPrivateGig: props.isPrivateGig,
                  },
                });
              }
            }}
          >
            {props.jobDetailScreenDimension ? null : (
              <Row className="jolisting-carddetail">
                {/* {props.jobdetpage && dimensions<770?  */}
                <Col span={24}>
                  <Row justify="space-between" wrap={false}>
                    <Col>
                      <Row
                        className={`${
                          props.isDeleted || props.closed
                            ? "joblisting-card-grey"
                            : props.jobdetpage
                            ? "joblisting-jobdet-title"
                            : "joblisting-title"
                        }`}
                        style={{ fontSize: dimensions < 845 && "14px" }}
                        justify={"space-between"}
                      >
                        <Tooltip title={props.title}>
                          <div
                            className="Job-Title"
                            style={{
                              width: "100%",
                              fontSize: "16px",
                              fontWeight: "500",
                            }}
                          >
                            {props.title}
                          </div>
                        </Tooltip>
                      </Row>
                      {/* Facility Row */}
                      <Row
                        className={`${
                          props.isDeleted || props.closed
                            ? "joblisting-card-grey"
                            : props.jobdetpage
                            ? "joblisting-jobdet-facility"
                            : "joblisting-facility"
                        }`}
                        style={{ fontSize: dimensions < 845 && "12px" }}
                        justify={"space-between"}
                        wrap={false}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          {props.jobdetpage ? (
                            <div style={{ marginRight: "2%" }}>
                              <img
                                src={facilitynameicon}
                                alt="facilityicon"
                                style={{ width: "16px", height: "16px" }}
                              ></img>
                            </div>
                          ) : null}
                          {props.professionCode == "IT" ? (
                            <Tooltip title={props.WorkplacePolicy}>
                              <div className="Job-Title-JobCard">
                                {props.WorkplacePolicy}
                              </div>
                            </Tooltip>
                          ) : (
                            <Tooltip title={props.facilityname}>
                              <div className="Job-Title-JobCard">
                                {props.facilityname}
                              </div>
                            </Tooltip>
                          )}
                          {
                            <div
                              className={`Job-Title-JobCard ${
                                props?.isPrivate === true
                                  ? null
                                  : "visibility-pvt-tag"
                              }`}
                            >
                              <img src={PrivateTag} alt="private" />
                              {/* <PrivateGigsTag/> */}
                            </div>
                          }
                        </div>
                      </Row>
                    </Col>
                    <Col>
                      <Row alignItems="flex-end" style={{ textAlign: "end" }}>
                        <Col span={24}>
                          <div className="jobcard-price2">
                            {isShowBudgetAmount()
                              ? `$${budget.toLocaleString("en-US")}`
                              : ""}
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="Job-Title-JobCard">
                            {/* {isShowBudgetAmount()
                              ? props?.budgetType == "hr"
                                ? "Per hour"
                                : "Per year"
                              : ""} */}
                            {isShowBudgetAmount()
                              ? props.JobOrderTypes?.JobOrderTypeName ==
                                "Permanent"
                                ? " Per year"
                                : " Per hour"
                              : ""}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  {props.professionCode == "IT" ? null : (
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 10px 0 0",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          className={`joblisting_star ${
                            props.isDeleted || props.closed
                              ? "joblisting-card-grey"
                              : "joblisting_star_color"
                          }`}
                        >
                          {props.jobDetailScreen == true ? (
                            <Rate
                              className={`joblisting_star ${
                                props.isDeleted || props.closed
                                  ? "joblisting-card-grey"
                                  : "joblisting_star_color"
                              }`}
                              allowHalf
                              disabled
                              defaultValue={
                                props?.title
                                  ?.toLowerCase()
                                  ?.includes("skillgigs")
                                  ? 4.5
                                  : props.rating
                                  ? props.rating
                                  : DefaultRating
                              }
                            />
                          ) : (
                            <StarFilled />
                          )}
                        </div>
                        <div
                          className={`joblisting-rating ${
                            props.isDeleted || props.closed
                              ? "joblisting-card-grey"
                              : "joblisting_star_color"
                          }`}
                        >
                          {" "}
                          {props.rating == null ||
                          props.rating == undefined ||
                          !props.rating ||
                          props.rating == 0
                            ? props?.title?.toLowerCase()?.includes("skillgigs")
                              ? 4.2
                              : DefaultRating
                            : props.rating}
                        </div>
                        <div className="joblisting-rating joblisting-sub">
                          {props.reviews == null ||
                          props.reviews == undefined ||
                          !props.reviews ||
                          props.reviews == 0
                            ? props?.title?.toLowerCase()?.includes("skillgigs")
                              ? "(49)"
                              : null
                            : `(${props.reviews})`}
                        </div>
                      </div>
                      <div
                        style={{
                          fontWeight: "400",
                          fontSize: "12px",
                          lineHeight: "16px",
                          color: "#7E7E7E",
                        }}
                      >
                        {getRelativeTime(props?.created)}
                      </div>
                    </Row>
                  )}
                </Col>
              </Row>
            )}
          </div>
        </div>

        {props.cardFooter || props?.cardFooterChoose ? (
          props?.JobOrderStatusName === "Expired" &&
          !props.isDeleted &&
          !props.closed ? (
            <div className="divContainer">
              <Button className="expBtn" onClick={extendExpiry}>
                Republish gig
              </Button>
            </div>
          ) : (
            <>
              {props.closed ? null : (
                <Row style={{ borderTop: "1px solid lightgrey" }}>
                  <Col
                    span={8}
                    className="joblisting-footer"
                    onClick={() => {
                      if (
                        props.matchedbids != 0 &&
                        !props?.cardFooterChoose &&
                        props.matchedbids != null
                      ) {
                        // dispatch(getSkillMatches(props.id));
                        history.push({
                          pathname: "/skillmatches",
                          state: {
                            id: props.id,
                            title: props.title,
                            jobOrderId: props?.JobOrderId,
                            fromMatches: true,
                            jobdetails: props.jobdetails,
                          },
                        });
                      }
                    }}
                  >
                    <Row
                      className={`joblisting-footer-txt ${
                        props.isDeleted
                          ? "joblisting-card-grey"
                          : props.indraft ||
                            props.matchedbids == 0 ||
                            props.matchedbids == null
                          ? "joblisting-card-faded"
                          : "joblisting-footer-txt_color"
                      } `}
                    >
                      {props.matchedbids || 0}
                    </Row>
                    <Row
                      className={`joblisting-footer-txt ${
                        props.isDeleted
                          ? "joblisting-card-grey"
                          : props.indraft ||
                            props.matchedbids == 0 ||
                            props.matchedbids == null
                          ? "joblisting-card-faded"
                          : "joblisting-footer-txt_color"
                      }`}
                    >
                      Matches
                    </Row>
                  </Col>
                  <Col span={8} className="joblisting-footer">
                    <Row
                      onClick={() => {
                        if (!props.placedbids == 0) {
                          dimensions < 768
                            ? history.push({
                                pathname: `/notification`,
                                state: {
                                  jobType: "bid",
                                  bidType: "placed",
                                  conversationStatus: "placed_bids",
                                  jobOrderId: props?.JobOrderId,
                                  openConversation: true,
                                  Icon: "message",
                                },
                              })
                            : history.push({
                                pathname: `/conversations`,
                                state: {
                                  jobType: "bid",
                                  bidType: "placed",
                                  conversationStatus: "placed_bids",
                                  jobOrderId: props?.JobOrderId,
                                  openConversation: true,
                                },
                              });
                        }
                      }}
                      className={`joblisting-footer-txt ${
                        props.isDeleted
                          ? "joblisting-card-grey"
                          : props.indraft || props.placedbids == 0
                          ? "joblisting-card-faded"
                          : "joblisting-footer-txt_color"
                      }`}
                    >
                      {props.placedbids}
                    </Row>
                    <Row
                      onClick={() => {
                        if (!props.placedbids == 0) {
                          dimensions < 768
                            ? history.push({
                                pathname: `/notification`,
                                state: {
                                  jobType: "bid",
                                  bidType: "placed",
                                  conversationStatus: "placed_bids",
                                  jobOrderId: props?.JobOrderId,
                                  openConversation: true,
                                  Icon: "message",
                                },
                              })
                            : history.push({
                                pathname: "/conversations",
                                state: {
                                  bidType: "placed",
                                  conversationStatus: "placed_bids",
                                  jobType: "bid",
                                  jobOrderId: props?.JobOrderId,
                                  openConversation: true,
                                },
                              });
                        }
                      }}
                      className={`joblisting-footer-txt ${
                        props.isDeleted
                          ? "joblisting-card-grey"
                          : props.indraft || props.placedbids == 0
                          ? "joblisting-card-faded"
                          : "joblisting-footer-txt_color"
                      }`}
                    >
                      {props.placedbids <= 1 ? "Placed bid" : "Placed bids"}
                    </Row>
                  </Col>
                  <Col span={8} className="joblisting-footer">
                    <Row
                      onClick={() => {
                        if (!props.receivedbids == 0) {
                          dimensions < 768
                            ? history.push({
                                pathname: `/notification`,
                                state: {
                                  jobOrderId: props?.JobOrderId,
                                  conversationStatus: "received_bids",
                                  jobType: "proposal",
                                  bidType: "received",
                                  openConversation: true,
                                  Icon: "message",
                                },
                              })
                            : history.push({
                                pathname: "/conversations",
                                state: {
                                  jobOrderId: props?.JobOrderId,
                                  conversationStatus: "received_bids",
                                  jobType: "proposal",
                                  bidType: "received",
                                  openConversation: true,
                                },
                              });
                        }
                      }}
                      className={`joblisting-footer-txt ${
                        props.isDeleted
                          ? "joblisting-card-grey"
                          : props.indraft || props.receivedbids == 0
                          ? "joblisting-card-faded"
                          : "joblisting-footer-txt_color"
                      }`}
                    >
                      {props.receivedbids}
                    </Row>
                    <Row
                      onClick={() => {
                        if (!props.receivedbids == 0) {
                          dimensions < 768
                            ? history.push({
                                pathname: `/notification`,
                                state: {
                                  jobOrderId: props?.JobOrderId,
                                  conversationStatus: "received_bids",
                                  jobType: "proposal",
                                  bidType: "received",
                                  openConversation: true,
                                  Icon: "message",
                                },
                              })
                            : history.push({
                                pathname: "/conversations",
                                state: {
                                  jobOrderId: props?.JobOrderId,
                                  conversationStatus: "received_bids",
                                  jobType: "proposal",
                                  bidType: "received",
                                  openConversation: true,
                                },
                              });
                        }
                      }}
                      className={`joblisting-footer-txt ${
                        props.isDeleted
                          ? "joblisting-card-grey"
                          : props.indraft || props.receivedbids == 0
                          ? "joblisting-card-faded"
                          : "joblisting-footer-txt_color"
                      }`}
                    >
                      {props.receivedbids <= 1
                        ? "Received bid"
                        : "Received bids"}
                    </Row>
                  </Col>

                  {/* <Col span={6}>
                  <Row
                    className={`joblisting-footer-txt ${props.isDeleted
                      ? "joblisting-card-grey"
                      : props.indraft || !props.candidates || props.candidates == 0
                        ? "joblisting-card-faded"
                        : "joblisting-footer-txt_color"
                      }`}
                  >
                    {props.candidates ? props.candidates : "0"}
                  </Row>
                  <Row
                    className={`joblisting-footer-txt ${props.isDeleted
                      ? "joblisting-card-grey"
                      : props.indraft || !props.candidates || props.candidates == 0
                        ? "joblisting-card-faded"
                        : "joblisting-footer-txt_color"
                      }`}
                  >
                    Candidates
                  </Row>
                </Col> */}
                </Row>
              )}
            </>
          )
        ) : null}
      </div>
    </>
  );
}
